/**
 * Single tunable sidenav sizing config.
 * Adjust values here during design/implementation — not a user preference.
 */
export const SIDENAV_TOKENS = {
  itemHeight: 44,
  /** Width of the primary accent ribbon on the active nav item. */
  activeAccentWidth: 3,
  /** Gap between the accent ribbon and the left edge of the nav item. */
  activeAccentInsetX: 4,
  /** Top/bottom inset so the ribbon sits free of the item edges. */
  activeAccentInsetY: 6,
  /** Corner radius of the accent ribbon. */
  activeAccentRadius: 2,
  /** Diameter of the primary indicator dot on the active child nav item. */
  activeChildDotSize: 6,
  /** Font/icon size when a child uses an icon as its active indicator. */
  activeChildIconSize: 12,
  childHeight: 34,
  /** Vertical gap below an expanded submenu to separate nav sections. */
  openMenuGap: 0.75,
  iconSize: 18,
  /** Gap between nav icon and label (MUI spacing units → 10px). */
  iconGap: 1.25,
  /** Shared label size for top-level and child nav items. */
  fontSize: '0.85rem',
  /** Horizontal inset for separators and group labels (MUI spacing units → 12px). */
  contentPaddingX: 1.25,
  identityRowHeight: 28,
  accountRowHeight: 36,
  /** Vertical gap between brand/notifications and account rows. */
  headerGap: 1.25,
  /** Bottom padding under the account row before the header divider. */
  headerPaddingBottom: 1,
  /** Top padding of the sidenav column above the brand row. */
  headerPaddingTop: 2,
  drawerWidth: 200,
  collapsedWidth: 48,
  /** Collapse/expand control size in the sidenav footer. */
  toggleButtonSize: 32,
  accountAvatarSize: 24,
  /** Avatar in the account popover user identity block. */
  accountPopoverAvatarSize: 28,
  brandMarkHeight: 20,
} as const;

/**
 * Left inset that centers a square control of `size` px in the collapsed rail.
 * Used expanded and collapsed so icons/avatars/toggles do not shift on toggle.
 */
export function getSidenavRailPaddingLeft(size: number) {
  return (SIDENAV_TOKENS.collapsedWidth - size) / 2;
}

/**
 * Aligns child label with parent text: iconPaddingLeft + iconSize + iconGap(10px).
 */
export function getSidenavChildIndent() {
  const iconGapPx = SIDENAV_TOKENS.iconGap * 8;
  return `${getSidenavRailPaddingLeft(SIDENAV_TOKENS.iconSize) + SIDENAV_TOKENS.iconSize + iconGapPx}px`;
}
